import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getImageUrl } from "utils/imageHelper";
import  useOffers  from "components/offers/hooks/useOffers";
import ImageViewer from "components/common/ImageViewer";


export default function View() {
  const { id } = useParams();
  const navigate = useNavigate(); 
  const { loadOfferById } = useOffers();
  const [offer, setOffer] = useState(null);
  
  const [viewerOpen, setViewerOpen] = useState(false);
  const [activeImage, setActiveImage] = useState(null);

  useEffect(() => {
    loadOfferById(id).then(setOffer);
  }, [id]);

  if (!offer) return null;

  const formatDateTime = (date) => {
  const d = new Date(date);
  const pad = (n) => String(n).padStart(2, "0");

  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}, ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`;
};



  return (
    <div className="p-6 space-y-8">

      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">Offer Details</h1>
        <button
          onClick={() => navigate(-1)}
          className="rounded-xl border px-4 py-2"
        >
          Back
        </button>
      </div>

    
    <Card title="Offer Details">
      <Info label="Title" value={offer.title} />
      <Info label="Exhibitor" value={offer.exhibitor_id?.title} />
      <Info label="Promo Code" value={offer.promo_code} />
      <Info label="Discount" value={`${offer.discount}%`} />
      <Info label="Start Date" value={formatDateTime(offer.start_date)} />
      <Info label="End Date" value={formatDateTime(offer.end_date)} />
      <Info label="Status" value={offer.status} />
      <Info
          label="Description"
          value={offer.description}
        />
      <Info
          label="Target Product"
          value={offer?.target_products
          ?.map((p) => p.product_name)
          .join(", ")}
        />
      <Info
          label="Terms & Conditions"
          value={offer.tc}
        />
    </Card>

    {(offer.offerImages?.length) && (
            <Card title="Offer Images">
              <div className="flex flex-wrap gap-4">
                {(offer.offerImages || [])
                  .filter(Boolean)
                  .map((img, index) => (
                    <img
                      key={index}
                      src={getImageUrl(img)}
                      alt="Offer"
                      className="h-24 w-auto rounded-xl border cursor-pointer object-contain"
                      onClick={() => {
                        setActiveImage(img);
                        setViewerOpen(true);
                      }}
                    />
                  ))}
              </div>
    
              <ImageViewer
                open={viewerOpen}
                onClose={() => setViewerOpen(false)}
                src={getImageUrl(activeImage)}
              />
            </Card>
          )}
    </div>
  );
}

function Card({ title, children }) {
  return (
    <div className="rounded-[20px] bg-white p-6 shadow-3xl">
      <h3 className="mb-4 text-lg font-semibold">{title}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {children}
      </div>
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div>
      <p className="text-sm text-gray-500">{label}</p>
      <p className="font-medium">{value || "-"}</p>
    </div>
  );
}
